import React, { useMemo } from 'react';
import { Modal, Button, Select } from '../ui';
import { useBuilderEditor } from '../../features/builder/BuilderEditorContext';

const flattenSections = (sections, depth = 0) => {
  const items = [];
  (sections || []).forEach((section) => {
    items.push({ id: section.id, title: section.title, depth });
    if (section.subSections?.length) {
      items.push(...flattenSections(section.subSections, depth + 1));
    }
  });
  return items;
};

const MoveFieldModal = () => {
  const {
    showMoveFieldModal,
    closeMoveFieldModal,
    fieldToMove,
    fieldFromSectionId,
    moveTargetSectionId,
    setMoveTargetSectionId,
    confirmMoveFieldToSection,
    formdata,
  } = useBuilderEditor();

  const sectionOptions = useMemo(() => {
    const fromId = fieldFromSectionId ?? 0;
    const options = [{ value: '', label: 'Select section…' }];

    if (fromId !== 0) {
      options.push({ value: '0', label: 'Questions (no section)' });
    }

    flattenSections(formdata?.sections).forEach((section) => {
      if (section.id !== fromId) {
        const prefix = section.depth > 0 ? `${'— '.repeat(section.depth)}` : '';
        options.push({ value: String(section.id), label: `${prefix}${section.title}` });
      }
    });

    return options;
  }, [formdata?.sections, fieldFromSectionId]);

  const canMove = moveTargetSectionId !== '' && moveTargetSectionId !== String(fieldFromSectionId ?? 0);

  return (
    <Modal
      show={showMoveFieldModal}
      onClose={closeMoveFieldModal}
      title="Move question"
      footer={
        <>
          <Button variant="secondary" onClick={closeMoveFieldModal}>Cancel</Button>
          <Button variant="primary" onClick={confirmMoveFieldToSection} disabled={!canMove}>
            Move
          </Button>
        </>
      }
    >
      <p className="builder-text-secondary builder-move-field-modal__hint">
        Move &ldquo;{fieldToMove?.name || 'Untitled question'}&rdquo; to another section.
      </p>
      <Select
        label="Destination section"
        value={moveTargetSectionId}
        onChange={(e) => setMoveTargetSectionId(e.target.value)}
        options={sectionOptions}
      />
    </Modal>
  );
};

export default MoveFieldModal;
